(function () {
  function safeParse(str) {
    if (!str) return null;

    // Decode HTML entities (&quot; etc.)
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    const raw = (txt.value || '').trim();

    if (!raw) return null;

    // Try JSON first, otherwise fallback to plain text
    try {
      const obj = JSON.parse(raw);
      return obj && typeof obj === 'object' ? obj : { text: raw };
    } catch (e) {
      return { text: raw };
    }
  }

  function init(block) {
    const openBtn = block.querySelector('[data-sg-open]');
    const modal = block.querySelector('[data-sg-modal]');
    const backdrop = block.querySelector('[data-sg-backdrop]');
    const closeBtn = block.querySelector('[data-sg-close]');
    if (!openBtn || !modal || !backdrop) return;

    // Parse data (HTML decode + JSON/plain-text)
    const sg = safeParse(block.getAttribute('data-sg'));
    const mm = safeParse(block.getAttribute('data-mm'));
    const diagramUrl = block.getAttribute('data-diagram');

    // === MODEL NOTE (before "Size guide" button) ===
    const noteEl = block.querySelector('[data-mm-note]');
    if (noteEl) {
      if (mm && mm.text) {
        noteEl.textContent = mm.text;
        noteEl.hidden = false;
      } else {
        noteEl.textContent = '';
        noteEl.hidden = true;
      }
    }

    // Move modal/backdrop to body (so they overlay correctly)
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    if (backdrop.parentElement !== document.body) document.body.appendChild(backdrop);

    // Diagram on the left
    const left = modal.querySelector('[data-sg-left]');
    if (left) {
      left.innerHTML = '';
      if (diagramUrl) {
        const img = document.createElement('img');
        img.src = diagramUrl;
        img.alt = 'Measurement diagram';
        img.className = 'blb-sg-diagram';
        img.loading = 'lazy';
        left.appendChild(img);
      }
    }

    // Product measurements (sizes + table)
    const productWrap = modal.querySelector('[data-sg-product]');
    const sizesWrap = modal.querySelector('[data-sg-sizes]');
    const rowsWrap = modal.querySelector('[data-sg-rows]');
    const unitBtns = modal.querySelectorAll('.blb-sg-unit');

    let activeUnit = 'cm';
    let activeSize = sg && sg.sizes && sg.sizes[0] ? String(sg.sizes[0]) : null;

    function toInch(cm) {
      return cm / 2.54;
    }

    function fmt(n) {
      const num = Number(n);
      if (Number.isNaN(num)) return '';
      return activeUnit === 'inch'
        ? (Math.round(toInch(num) * 100) / 100).toFixed(2) + '"'
        : (Math.round(num * 10) / 10).toFixed(1) + ' cm';
    }

    function renderSizes() {
      if (!sg || !sizesWrap) return;
      sizesWrap.innerHTML = '';
      (sg.sizes || []).forEach((s) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'blb-sg-size' + (String(s) === activeSize ? ' is-active' : '');
        b.textContent = s;
        b.addEventListener('click', () => {
          activeSize = String(s);
          renderRows();
          renderSizes();
        });
        sizesWrap.appendChild(b);
      });
    }

    function renderRows() {
      if (!sg || !rowsWrap || !activeSize) return;
      rowsWrap.innerHTML = '';

      const labels = sg.labels || {};
      const cmMap = sg.cm && sg.cm[activeSize] ? sg.cm[activeSize] : null;
      if (!cmMap) return;

      Object.keys(cmMap).forEach((k) => {
        const tr = document.createElement('tr');
        const td1 = document.createElement('td');
        const td2 = document.createElement('td');

        td1.textContent = labels[k] || k;
        td2.textContent = fmt(cmMap[k]);

        tr.appendChild(td1);
        tr.appendChild(td2);
        rowsWrap.appendChild(tr);
      });
    }

    if (productWrap) {
      productWrap.hidden = !sg;
      if (sg) {
        renderSizes();
        renderRows();
      }
    }

    // Force CM only + keep UI consistent
    activeUnit = 'cm';
    unitBtns.forEach((x) => x.classList.toggle('is-active', x.getAttribute('data-unit') === 'cm'));

    // Model measurements box inside popup
    const modelWrap = modal.querySelector('[data-sg-model]');
    function renderModel() {
      if (!modelWrap) return;

      modelWrap.hidden = !mm;
      if (!mm) return;

      modelWrap.innerHTML = '';

      const t = document.createElement('div');
      t.className = 't';
      t.textContent = 'MISURE MODELLO';
      modelWrap.appendChild(t);

      if (mm.text) {
        const p = document.createElement('div');
        p.className = 'p';
        p.textContent = mm.text;
        modelWrap.appendChild(p);
      }

      (mm.rows || []).forEach((r) => {
        const row = document.createElement('div');
        row.className = 'r';

        const a = document.createElement('div');
        a.textContent = r.label || '';

        const c = document.createElement('div');
        c.textContent = r.value || '';

        row.appendChild(a);
        row.appendChild(c);
        modelWrap.appendChild(row);
      });
    }
    renderModel();

    // Returns box: sempre visibile (anche se non c'è mm)
    const returnsWrap = modal.querySelector('.blb-sg-returns');
    if (returnsWrap) returnsWrap.hidden = false;

    // Open/close
    function open() {
      backdrop.hidden = false;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      backdrop.hidden = true;
      document.documentElement.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    // ESC close (single listener per modal)
    if (!modal.__blbEscBound) {
      modal.__blbEscBound = true;
      document.addEventListener('keydown', (e) => {
        if (!modal.hidden && e.key === 'Escape') close();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.blb-sg').forEach(init);
  });
})();
